import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";
import { Form, Select, Input } from "formik-antd";

import { BasicForm } from "../../../../../core/components/form";

import { Divider } from "antd";
import { InputDate } from "../../../../../core/components/form";

import { DownloadOutlined } from "@ant-design/icons";
//import { StepsForm } from "../show/steps";

const LoginSchema = Yup.object().shape({
    date: Yup.date().required("Cannot be blank").typeError("Must be a date"),
    code: Yup.string().required("Cannot be blank"),
    client: Yup.string().required("Client cannot be blank."),
});

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
};

/**
 *
 */
const Formulario = (props) => {
    const { alta, loaded, data } = props;

    const _goBack = () => {
        props.history.goBack();
    };

    const _initialForm = () => {
        if (!alta && loaded && data) {
            //NO HAY EDICION DE PO
            return {
                client: "",
                file: null,
                code: "",
                date: "",
            };
        } else {
            return {
                client: "",
                file: null,
                code: "",
                date: "",
            };
        }
    };

    return (
        <BasicForm
            onPressBack={_goBack}
            titulo="ADD PURCHASE ORDER"
            subtitulo="FORM"
            initialValues={_initialForm()}
            validationSchema={LoginSchema}
            onSubmit={props.handleSubmit}
            extra={[
                <a href="/empty.xlsx" target="_blank" className="ant-btn ant-btn-default" key="1">
                    <DownloadOutlined /> <Divider type="vertical" /> Empty XLS
                </a>,
            ]}
            render={({ isSubmitting, touched, errors, values, setFieldValue }) => (
                <>
                    {/*<StepsForm />*/}

                    <br />
                    <Form.Item label="Clients" name="client" hasFeedback={true} showValidateSuccess={true}>
                        <Select
                            placeholder="Client"
                            name="client"
                            showSearch
                            options={props.clients}
                            filterOption={_filter}
                        />
                    </Form.Item>

                    <InputDate
                        name="date"
                        label="Date"
                        placeholder="Date"
                        errors={errors.date}
                        touched={touched.date}
                        layout="horizontal"
                        formItemLayout={formItemLayout}
                    />

                    <Form.Item label="Code" name="code" hasFeedback={true} showValidateSuccess={true}>
                        <Input name="code" placeholder="Code" />
                    </Form.Item>

                    <Divider orientation="left" plain>
                        {" "}
                        File
                    </Divider>

                    <Form.Item name="file" label="File">
                        <input
                            id="file"
                            name="file"
                            type="file"
                            onChange={(event) => {
                                setFieldValue("file", event.currentTarget.files[0]);
                            }}
                            className="form-control"
                        />
                    </Form.Item>
                </>
            )}
        />
    );
};

export default Formulario;
